import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DeerFlowState, TDeerFlowInstance } from "./types";
import {
  createDeerFlowInstanceThreadReducerBuilder,
  deleteDeerFlowInstanceThreadReducerBuilder,
  generateDeerFlowInstancesReducerBuilder,
  getDeerFlowInstanceAgentsReducerBuilder,
  getDeerFlowInstanceThreadsReducerBuilder,
  getDeerFlowThreadMessagesReducerBuilder,
  postDeerFlowThreadMessageReducerBuilder,
} from "./reducers";
import {
  TDeerFlowInstanceAgent,
  TDeerFlowThread,
} from "../../../services/api/instances/deerflowApi/types";
import { ChatCompletionsMessageObject } from "../../../services/api/instances/completionsApi/types";

const initialState: DeerFlowState = {
  deerFlowInstances: [],
  selectedDeerFlowInstance: null,
  instanceAgents: [],
  selectedInstanceAgent: null,
  instanceThreads: [],
  selectedInstanceThread: null,
  messages: [],
  isMessageLoading: false,
};

const deerFlowSlice = createSlice({
  name: "deerflow",
  initialState,
  reducers: {
    setDeerFlowInstances: (
      state,
      action: PayloadAction<TDeerFlowInstance[]>,
    ) => {
      state.deerFlowInstances = action.payload;
    },
    setSelectedDeerFlowInstances: (
      state,
      action: PayloadAction<TDeerFlowInstance | null>,
    ) => {
      state.selectedDeerFlowInstance = action.payload;
    },
    setSelectedDeerFlowInstancesAgent: (
      state,
      action: PayloadAction<TDeerFlowInstanceAgent | null>,
    ) => {
      state.selectedInstanceAgent = action.payload;
    },

    setSelectedInstanceThread: (
      state,
      action: PayloadAction<TDeerFlowThread | null>,
    ) => {
      state.selectedInstanceThread = action.payload;
    },
    addUserMessage: {
      reducer(
        state: DeerFlowState,
        action: PayloadAction<ChatCompletionsMessageObject>,
      ) {
        state.messages.push(action.payload);
      },
      prepare(content: string) {
        return {
          payload: {
            role: "user",
            content,
          },
        };
      },
    },
    clearInstanceState: (state) => {
      state.instanceAgents = [];
      state.instanceThreads = [];
      state.selectedInstanceAgent = null;
      state.selectedInstanceThread = null;
      state.messages = [];
    },
    clearMessages: (state) => {
      state.messages = [];
    },
  },
  extraReducers: (builder) => {
    generateDeerFlowInstancesReducerBuilder(builder);
    getDeerFlowInstanceAgentsReducerBuilder(builder);
    getDeerFlowInstanceThreadsReducerBuilder(builder);
    getDeerFlowThreadMessagesReducerBuilder(builder);
    postDeerFlowThreadMessageReducerBuilder(builder);
    createDeerFlowInstanceThreadReducerBuilder(builder);
    deleteDeerFlowInstanceThreadReducerBuilder(builder);
  },
});

export const deerflowReducers = deerFlowSlice.reducer;
export const {
  setDeerFlowInstances,
  setSelectedDeerFlowInstances,
  setSelectedDeerFlowInstancesAgent,
  setSelectedInstanceThread,
  addUserMessage,
  clearMessages,
  clearInstanceState,
} = deerFlowSlice.actions;
